import { useMemo } from 'react';
import { useFleetStore } from '@/stores/fleet';
import { collectTagIds } from '@/lib/tag';
import type { Device } from '@/api/types';

/** Set de ids que são Tag vinculada (não são máquinas). */
export function useTagIds(): Set<number> {
  const devices = useFleetStore((s) => s.devices);
  return useMemo(() => collectTagIds(devices.values()), [devices]);
}

/**
 * Lista APENAS as máquinas (exclui as Tags vinculadas). As Tags seguem no fleet
 * store para a localização via a máquina vinculada, mas não aparecem em listas,
 * contagens nem seletores de relatório.
 */
export function useMachines(): Device[] {
  const devices = useFleetStore((s) => s.devices);
  return useMemo(() => {
    const tagIds = collectTagIds(devices.values());
    return [...devices.values()].filter((d) => !tagIds.has(d.id));
  }, [devices]);
}
